import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetFirstLastTimeAcrossCoursesPatron_facilities$key } from "./__generated__/useGetFirstLastTimeAcrossCoursesPatron_facilities.graphql";

export type firstTimeLastTime = {
  firstTime: null | string;
  lastTime: null | string;
};

export const useGetFirstLastTimeAcrossCoursesPatron = ({
  facilityRefs,
}: {
  facilityRefs: useGetFirstLastTimeAcrossCoursesPatron_facilities$key | null;
}) => {
  const facilities = useFragment(
    useGetFirstLastTimeAcrossCoursesPatronFragmentString,
    facilityRefs
  );

  const agendaTimes = facilities?.flatMap((facility) => {
    return (
      facility?.agendas?.edges?.flatMap((edge) => {
        const firstTime = edge?.node?.timeSlots?.firstDateTime;
        const lastTime = edge?.node?.timeSlots?.lastDateTime;

        return firstTime && lastTime ? [{ firstTime, lastTime }] : [];
      }) ?? []
    );
  });

  const returnTimes = agendaTimes?.reduce(
    (acc: firstTimeLastTime, cur) => {
      return {
        firstTime:
          !acc.firstTime || cur.firstTime < acc.firstTime
            ? cur.firstTime
            : acc.firstTime,
        lastTime:
          !acc.lastTime || cur.lastTime > acc.lastTime
            ? cur.lastTime
            : acc.lastTime,
      };
    },
    { firstTime: null, lastTime: null }
  );

  return returnTimes;
};

const useGetFirstLastTimeAcrossCoursesPatronFragmentString = graphql`
  fragment useGetFirstLastTimeAcrossCoursesPatron_facilities on Facility
  @relay(plural: true) {
    id
    type
    agendas(dateGte: $date, dateLte: $date) {
      edges {
        node {
          id
          timeSlots(first: 1000, courseIds: $courseIds) {
            firstDateTime
            lastDateTime
          }
        }
      }
    }
  }
`;
